import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { TextField, makeStyles } from '@material-ui/core'
import { filterAddressOptions } from './address-data'

const useStyles = makeStyles(() => ({
  root: { marginBottom: 16, '& input, & label': { fontFamily: '"Times New Roman", Times, serif' } },
  inputRoot: { minHeight: 50, boxShadow: '0px 3px 6px #00000029', fontWeight: 700 },
  option: { fontFamily: '"Times New Roman", Times, serif', fontSize: '1rem' }
}))

export default function AddressAutocomplete({ id, name, label, value = '', onChange, onBlur, options, numeric, placeholder, helperText, error, onSelect }) {
  const classes = useStyles()
  return <Autocomplete
    id={id}
    freeSolo
    autoHighlight
    value={value || ''}
    inputValue={value || ''}
    options={options}
    classes={{ root: classes.root, inputRoot: classes.inputRoot, option: classes.option }}
    getOptionLabel={option => typeof option === 'string' ? option : option.label}
    getOptionSelected={(option, selected) => option.value === (typeof selected === 'string' ? selected : selected.value)}
    filterOptions={items => filterAddressOptions(items, value || '', numeric)}
    onInputChange={(event, text, reason) => { if (reason === 'input' || reason === 'clear') onChange(text) }}
    onChange={(event, option) => {
      onChange(typeof option === 'string' ? option : option ? option.value : '')
      if (option && typeof option !== 'string' && onSelect) onSelect(option)
    }}
    onBlur={onBlur}
    clearText="Cancella"
    openText="Mostra suggerimenti"
    closeText="Chiudi suggerimenti"
    renderInput={params => <TextField {...params} name={name} label={label} variant="outlined" placeholder={placeholder}
      error={error} helperText={helperText}
      inputProps={{ ...params.inputProps, inputMode: numeric ? 'numeric' : 'text', autoComplete: numeric ? 'postal-code' : 'address-level2' }}
    />}
  />
}
